import { TLDL_MAX_EPISODE_COUNT } from 'utils/constants';
import { useTldlEpisodeCount } from './tldl';

export default function useHasReachedEpisodeLimit() {
  const count = useTldlEpisodeCount();

  return count >= TLDL_MAX_EPISODE_COUNT;
}
